import {useTranslation} from "react-i18next";

export const BoardType = () => {
  const {t} = useTranslation();

  return [
    {id: "NO_BOARD", name: t('request.no_board')},
    {id: "BED_AND_BREAKFAST", name: t('request.bed_and_breakfast')},
    {id: "HALF_BOARD", name: t('request.half_board')}
  ];
}
